import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Header from '@/components/Header2.vue'
import Main from '@/components/Main.vue'
import DeviceList from '@/components/device/DList.vue'
import DeviceEdit from '@/components/device/DeviceEdit.vue'
import CreateInstance from '@/components/instance/CreateInstance.vue'
import Login from '@/components/login/Login.vue'
import InstanceList from '@/components/instance/InstanceList.vue'
import MonitorManager from '@/components/monitor/MonitorManager.vue'
import NetworkUnitType from '@/components/monitor/NetworkUnitType.vue'
import NetworkUnitInstance from '@/components/monitor/NetworkUnitInstance.vue'
import ModuleType from '@/components/monitor/ModuleType.vue'
import ModuleInstance from '@/components/monitor/ModuleInstance.vue'
import DashBoard  from '@/components/monitor/DashBoard.vue'
import TaskPlan from '@/components/monitor/TaskPlan.vue'
import InstanceModuleUpdate from '@/components/instance/ModuleUpdate.vue'
import DataAnalysis from '@/components/dataanalysis/AnalysisManager.vue'
import Analysislist from '@/components/dataanalysis/DataTable.vue'
import AnalysisGroup from '@/components/dataanalysis/DataGroup.vue'
import Noun from '@/components/help/Noun.vue'
import Apimonitor from '@/components/grafna/Apimonitor.vue'
import IpLimit from '@/components/iplimit/IpLimit.vue'
import Interface from '@/components/interface/Interface.vue'

import Grafna from '@/components/grafna/Grafna.vue'
import SysArea from '@/components/area/SysArea.vue'
import qos from '@/components/qos/Qos'
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    // redirect: '/container/devicelist',
    redirect: '/login',
    children: [
      {
        path: 'container',
        components: {
          default: Main,
          vheader: Header
        },
        children: [
          {
            path: 'interface', //设备
            name: 'interface',
            component: Interface
          },
          {
            path: 'devicelist', //设备
            name: 'devicelist',
            component: DeviceList
          },
          {
            path: 'deploy', //部署
            component: Main,
            children: [
              {// 创建实例
                path: 'instancecreate',
                name: 'deployinstance',
                component: CreateInstance
              },
              {// 实例列表
                path: 'instancelist',
                name: 'deployinstancelist',
                component: InstanceList
              },{
                path: 'instancemoduleupdate',
                name: 'deployinstancemoduleupdate',
                component: InstanceModuleUpdate
              },
              {
                path: 'depended',
                name: 'deploydepended',
                component: ()=> import('@/components/instance/InstanceDepended.vue')
              },
              {// 创建编排
                path: 'arrage',
                name: 'deployarrage',
                component: () => import('@/components/arrange/ArrangeEdit')
              },{
                // 编排列表
                path: 'arrangelist',
                name: 'deployarrangelist',
                component: () => import('@/components/arrange/ArrangeList')
              }
            ]
          },
          {//监控
            path: 'monitor',
            // name: 'monitor',
            // component: MonitorManager,
            component: Main,
            children: [
              {
                path: 'manager',
                name: 'monitormanager',
                component: MonitorManager
              },
              { //网元类型
                path: 'nettype',
                name: 'monitornettype',
                component: NetworkUnitType
              },
              { //网元实例
                path: 'netinstance',
                name: 'monitornetinstance',
                component: NetworkUnitInstance
              },
              {
                // 模块类型
                path: 'moduletype',
                name: 'monitormoduletype',
                component: ModuleType
              },
              {
                // 模块实例
                path: 'moduleinstance',
                name: 'monitormoduleinstance',
                component: ModuleInstance
              },
              {
                // 任务计划
                path: 'taskplan',
                name: 'monitortaskplan',
                component: TaskPlan
              },
              {
                // 仪表盘
                path: 'dashboard',
                name: 'dashboard',
                component: DashBoard
              },
            ]
          },
          {//数据分析
            path: 'analysis',
            // name: 'analysis',
            component: Main,
            children: [
              {
                path: 'list',
                name: 'analysislist',
                component: Analysislist
              },{
                path: 'group',
                name: 'analysisgroup',
                component: AnalysisGroup
              }
            ]
          },
          {
            path: 'help',
            name: 'help',
            component: ()=> import('@/components/help/Help.vue')
          },
          // 角色管理
          {
            path: 'role',
            name: 'role',
            component: ()=>import('@/components/role/RoleList')
          },
          // 用户管理
          {
            path: 'user',
            name: 'user',
            component: ()=>import('@/components/user/UserList')
          },
          //MongoDB管理
          {
            path: 'MongoDB',
            name: 'MongoDB',
            component: ()=>import('@/components/MongoDB/DelMongoDB')
          },
          // 菜单管理
          {
            path: 'menu',
            name: 'menu',
            component: ()=>import('@/components/menu/MenuManager')
          },
          //ip限制
          {
            path: 'ipLimit',
            name: 'ipLimit',
            component: ()=>import('@/components/iplimit/IpLimit')
          },
          // 操作管理
          {
            path: 'func',
            name: 'func',
            component: ()=>import('@/components/menu/MenuOperation')
          },
          {
            // 名词解释
            path: 'noun',
            name: 'Noun',
            component: Noun
          },
          // 日志分析
          {
            path: 'logs',
            component: Main,
            children: [
              // 服务日志
              {
                path: 'serverlogs',
                name: 'Serverlogs',
                component: () => import(/* webpackChunkName:'logs'*/'@/components/logs/Logs.vue')
              },
              // 终端日志
              {
                path: 'terminallogs',
                name: 'Terminallogs',
                component: () => import(/* webpackChunkName:'logs'*/'@/components/logs/TerminalLogs.vue')
              },
              // 行为日志
              {
                path: 'actionlogs',
                name: 'actionlogs',
                component: () => import(/* webpackChunkName:'logs'*/'@/components/logs/Actionlogs.vue')
              },
              // 地址解析
              {
                path: 'addressLogs',
                name: 'addressLogs',
                component: () => import(/* webpackChunkName:'logs'*/'@/components/logs/AddressLogs.vue')
              },
            ]
          },
          // 监控告警
          {
            path: 'alarm',
            // name: 'Grafna',
            component: Main,
            // component: Grafna,
            children: [
              {
                path: 'grafna',
                name: 'Grafna',
                component: () => import('@/components/grafna/Grafna.vue')
              },
              {
                path: 'alertinfo',
                name: 'alertInfo',
                component: () => import('@/components/grafna/AlertInfo.vue')
              },
              {
                path: 'apimonitor',
                name: 'Apimonitor',
                component: () => import('@/components/grafna/Apimonitor.vue')
              },
              // {
              //   path: 'alertinfo11',
              //   name: 'Alertinfo11',
              //   component: () => import('@/components/grafna/AlertInfo.vue')
              // },
              {
                path: 'apilog',
                name: 'Apilog',
                component: () => import('@/components/grafna/ApiLog.vue')
              },

              {
                path: 'reportList',
                name: 'ReportList',
                component: () => import('@/components/grafna/ReportList.vue')
              },
              {
                path: 'reportDetail',
                name: 'ReportDetail',
                component: () => import('@/components/grafna/ReportDetail.vue')
              },
            ]
          },
          {
            path: 'detect',
            component: Main,
            children: [
              // 网络探测
              {
                path: 'net',
                name: 'detectnet',
                component: () => import(/* webpackChunkName:'detect'*/'@/components/detect/NetWorkDetect')
              },
              // 带宽探测
              {
                path: 'web',
                name: 'detectweb',
                component: () => import(/* webpackChunkName:'detect'*/'@/components/detect/WebDetect')
              },
              // 开箱探测
              {
                path: 'events',
                name: 'detectevents',
                component: () => import(/* webpackChunkName:'detect'*/'@/components/detect/Events')
              }
            ]
          },
          {
            path: 'nps',
            component: Main,
            children: [
              // 以下为nps相关
              // {
              // 	path: 'Menu',
              // 	name: 'Menu',
              // 	component: () => import(/* webpackChunkName:'nps'*/'@/components/nps/menu/menu')
              // },
              {
                path: '/Submenu',
                name: 'Submenu',
                component: () => import(/* webpackChunkName:'nps'*/'@/components/nps/menu/submenu')
              },
              {
                path: 'Content',
                name: 'Content',
                component: () => import(/* webpackChunkName:'nps'*/'@/components/nps/content/content')
              },
              {
                path: 'Terminal/:tid/:Tval',
                name: 'Terminal',
                // path: 'Menu/Terminal/:pid/:tid/Tval=:Tval/Sval=:Sval',
                // name: 'Terminal',
                component: () => import(/* webpackChunkName:'nps'*/'@/components/nps/menu/terminal')
              },
              {
                path: 'Public',
                name: 'Public',
                component: () => import(/* webpackChunkName:'nps'*/'@/components/nps/public/public')
              },
              {
                path: '/Src',
                name: 'Src',
                // path: 'Src',
                // name: 'Src',
                component: () => import(/* webpackChunkName:'nps'*/'@/components/nps/ota/src')
              },
              {
                path: '*',
                redirect: {
                  name: 'Submenu'
                }
              }
            ]
          },

          {
            path: 'qos',
            // name: 'qos',
            component: Main,
            // component: () => import(/* webpackChunkName:'qos'*/'@/components/qos/Qos')
            children: [
              // qos
              {
                path: 'qos',
                name: 'qos',
                component: () => import(/* webpackChunkName:'qos'*/'@/components/qos/Qos')
              },
              // 事件订阅
              {
              	path: 'eventsubscribe',
              	name: 'EventSubscribe',
              	component: () => import(/* webpackChunkName:'qos'*/'@/components/qos/EventSubscribe')
              },
              // 错误回调
              {
              	path: 'callback',
              	name: 'Callback',
              	component: () => import(/* webpackChunkName:'qos'*/'@/components/qos/ErrorCallback')
              },
              // 首页
              // {
              // 	path: 'overview',
              // 	name: 'Overview',
              // 	component: () => import(/* webpackChunkName:'qos'*/'@/components/qos/Overview')
              // },
              // {
              // 	path: 'statistic',
              // 	name: 'Statistic',
              // 	component: () => import(/* webpackChunkName:'qos'*/'@/components/qos/statistic/StatisticManager'),
              //   children: [
              //     {
              //       // 端到端分析
              //       path: 'ctc',
              //       name: 'CTC',
              //       component: () => import(/* webpackChunkName:'qos'*/'@/components/qos/statistic/CToC')
              //     }
              //   ]
              // }
            ]
          },
          // 地区管理
          {
            path: 'sysArea',
            name: 'SysArea',
            component: SysArea
          },
          //httpdns
          {
            path: 'httpdns',
            component: Main,
            children: [
              // 以下为httpdns相关
              {
                path: 'map',
                name: 'map',
                component: () => import('@/components/httpdns/map')
              },
              {
                path: 'showmap',
                name: 'showmap',
                component: () => import('@/components/httpdns/ShowMap')
              },
            ]
          },
          {
            path: 'idc',
            component: Main,
            children: [
              // 以下为idc相关
              {
                path: 'idclist',
                name: 'idclist',
                component: () => import(/* webpackChunkName:'idc'*/'@/components/idc/IdcList')
              },
              {
                path: 'idcdevicelist/:idcId',
                name: 'idcdevicelist',
                component: () => import(/* webpackChunkName:'idc'*/'@/components/idc/device/DeviceList')
              },
              {
                path: 'publiciplist/:idcId',
                name: 'publiciplist',
                component: () => import(/* webpackChunkName:'idc'*/'@/components/idc/publicip/PublicIpList')
              },
              {
                path: 'privatenetplane/:idcId',
                name: 'privatenetplane',
                component: () => import(/* webpackChunkName:'idc'*/'@/components/idc/privatenetplane/PrivateNetPlane')
              },
              {
                path: 'ipaddrmanage/:idcId/:netPlaneId',
                name: 'ipaddrmanage',
                component: () => import(/* webpackChunkName:'idc'*/'@/components/idc/ipaddrmanage/IPAddrMan')
              },{
                path: 'pubenetplane',
                name: 'pubenetplane',
                component: () => import(/* webpackChunkName:'idc'*/'@/components/idc/pubnetplane/PubNetPlane')
              },{
                path: 'butelproxylist/:idcId/:flag',
                name: 'butelproxylist',
                component: () => import(/* webpackChunkName:'idc'*/'@/components/idc/butelproxy/ButelProxyList')
              },
              {
                path: 'groupinfomanager',
                name: 'groupinfomanager',
                component: () => import(/* webpackChunkName:'idc'*/'@/components/idc/groupinfomanager/GroupInfo')
              },
              {
                path: 'platmapinfo',
                name: 'platmapinfo',
                component: () => import(/* webpackChunkName:'idc'*/'@/components/idc/platmapinfo/PlatMapInfo')
              }, {
                path: 'updateagent',
                name: 'updateagent',
                component: () => import(/* webpackChunkName:'idc'*/'@/components/idc/UpdateAgent.vue')
              },
            ]
          },
        ]
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/dv',
    name: 'device',
    component: DeviceEdit
  },{
    path: '/ci',
    name: 'instance',
    component: CreateInstance
  },
  {
    path: '/monitor',
    name: 'monitor',
    redirect: '/monitor/device',
    component: ()=>import('../views/Monitor.vue'),
    children: [{
      path: 'device',
      name: 'monitordevice',
      component: MonitorManager
    },{
      path: 'instance',
      name: 'monitorinstance',
      component: ModuleInstance
    },{
      path: 'module',
      name: 'monitormodule',
      component: ModuleType
    }]
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/components/test')
  }

]

const router = new VueRouter({
  routes
})

export default router
